import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, LoadingController, Events } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoPatronDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-patron-details',
  templateUrl: 'co-patron-details.html',
})
export class CoPatronDetailsPage {
  patron: any;
  sharedScreen: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public loading: LoadingController, private events : Events, private timeout : TimeoutFunctionsProvider, private viewCtrl : ViewController, private state: AppState) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    if (this.navParams.data.patron) {
      this.patron = this.navParams.data.patron;
      this.patron.firstName = this.patron.firstName;
      this.patron.lastName = this.patron.lastName;
      if (this.patron.address){
        this.patron.street = this.patron.address[0];
        this.patron.city = this.patron.address[1].split(', ')[0];
        this.patron.state = this.patron.address[1].split(', ')[1].split(' ')[0];
        this.patron.zip = this.patron.address[1].split(', ')[1].split(' ')[1];
      }
      this.sharedScreen = this.state.sharedScreen;
      // this.patron.pickupBranch = this.patron.pickupLocation.name;
      if (this.patron.homeBranch) this.patron.branch = this.patron.homeBranch.name;
    }
  }

  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-patron-details/co-patron-details.ts